import { render, staticRenderFns } from "./closing.vue?vue&type=template&id=068b56c7&scoped=true"
import script from "./closing.vue?vue&type=script&lang=js"
export * from "./closing.vue?vue&type=script&lang=js"
import style0 from "./closing.vue?vue&type=style&index=0&id=068b56c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b56c7",
  null
  
)

export default component.exports